<script>
    import { onMount } from "svelte";
    import Conexoes from "../Classes/Conexoes";
    import Constantes from "../Classes/Constantes";
    import { ItemInserir, Tipo } from "../Classes/ItemInserir";
    import CaixaDeDialogo from "./CaixaDeDialogo.svelte";
    import LoadingTela from "./LoadingTela.svelte";
    import { Notification, Button, Input } from "@svelteuidev/core";
    import { fade } from "svelte/transition";
    import { ConfirmaEmail } from "../Classes/Stores";
    export let showModal = true;
    let msgConfirmacao =
        "Para finalizar o cadastro, digite o token de 6 dígitos enviado ao seu email e telefone.";
    let token = "";
    let titulo = "Confirmar dados";
    let mensagemToast;
    let confirmou = true;
    export let email;
    onMount(() => EnviaSMS());
    function Sucesso() {
        console.log("sucesso");
        ConfirmaEmail.update((current) => ({
            ...current,
            email_confirmado: true,
        }));
        showModal = false;
        carregando = false;
        mensagemToast = "Token confirmado com sucesso!";
        setTimeout(() => {
            showNotification = false;
        }, 3000); // 3 segundos
        confirmou = true;
    }

    function NaoConfirmado() {
        msgConfirmacao =
            "Token inválido, digite novamente ou clique em reenviar token";
        // Adicione uma ação adicional, como mostrar uma mensagem na interface do usuário
        mensagemToast =
            "Token inválido, por favor, verifique e tente novamente.";
        setTimeout(() => {
            mensagemToast = ""; // Limpa a mensagem após alguns segundos
        }, 3000); // Define a mensagem de volta para vazia após 3 segundos
        confirmou = false;
    }

    function ChamarConfirmacao() {
        console.log("chamando confirmacao");
        showModal = false;
        msgConfirmacao =
            "Um sms foi enviado ao seu telefone com um token. Digita o token para confirmar dados!";
    }

    let conexao = new Conexoes();
    let resultado;
    let api = Constantes.api_consultar_sem_retorno;
    let parametros;
    let carregando = false;
    let showNotification = true;

    async function ConfirmaToken() {
        carregando = true;

        resultado = await conexao.conecta(api, {
            query_code: "confirma_token",
            token_confirmacao: token,
            email: email,
        });
        carregando = false;

        let confirmou = false;
        if (resultado && resultado.retornou) {
            confirmou = true;
        }
        if (confirmou) {
            Sucesso();
        } else {
            NaoConfirmado();
        }
    }
    async function EnviaSMS() {
        carregando = true;

        resultado = await conexao.conecta(Constantes.api_enviar_email_sms, {});
        carregando = false;
    }
    function closeDialog() {
        showModal = false;
        ConfirmaEmail.update((current) => ({
            ...current,
            email_confirmado: false,
        }));
    }

    async function Reenviar() {
        carregando = true;

        resultado = await conexao.conecta(api, {
            query_code: "reenvia_token",
            email: email,
        });
        carregando = false;

        let confirmou = false;
        if (resultado) {
            if (resultado[0]) {
                if (resultado[0].id) {
                    confirmou = true;
                }
            }
        }

        await EnviaSMS();
    }
</script>

{#if mensagemToast && showNotification}
    <div transition:fade class="notification-container">
        <Notification title="Atenção">
            {mensagemToast}
        </Notification>
    </div>
{/if}

<LoadingTela isLoading={carregando} />

{#if showModal}
    <div class="modal">
        <div class="modal-content">
            <div class="modal-header">
                <h2>{titulo}</h2>
                <button class="close-button" on:click={closeDialog}
                    >&times;</button
                >
            </div>
            <div class="modal-body">
                <p class:invalid={!confirmou}>{msgConfirmacao}</p>
                <Input
                    type="text"
                    bind:value={token}
                    placeholder="Digite o token"
                />
            </div>
            <div class="modal-footer">
                <Button variant="outline" on:click={Reenviar}
                    >Reenviar token</Button
                >
                <Button on:click={ConfirmaToken}>Confirmar</Button>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 1050;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .modal-body .invalid {
        color: red;
    }
    .notification-container {
        position: fixed;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2000;
        opacity: 1;
    }
    .modal-content {
        background-color: #fefefe;
        padding: 20px;
        border: 1px solid #888;
        border-radius: 10px;
        position: relative;
        max-width: 80%; /* Default for mobile */
    }

    @media (min-width: 768px) {
        /* Adjust the breakpoint as needed */
        .modal-content {
            max-width: 30%;
        }
    }

    .close-button {
        color: #aaa;
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 20px;
        font-weight: bold;
        border: none;
        background: none;
        cursor: pointer;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: center;
    }

    .modal-footer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        flex-wrap: nowrap;
    }

    p {
        margin: 0 0 10px;
    }
</style>
